export const IMG = {
  hero: "https://images.unsplash.com/photo-1618298363483-e31a31f1a1e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  driver2: "https://images.unsplash.com/photo-1760504429792-3c6a06b09e02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  driver3: "https://images.unsplash.com/photo-1636472537786-a6f3f7f9626f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  community: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hands: "https://images.unsplash.com/photo-1556484687-30636164638b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  logistics: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  training: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
